// extracted by mini-css-extract-plugin
export default {"normal":"WhiteFlash_normal__2Y7jX","doTransition":"WhiteFlash_doTransition__7hshv"};